
import "bootstrap/dist/css/bootstrap.min.css";
import Dashboard from './views/Dashboard';
import './App.scss';

function App() {
  return (
    <Dashboard />
  );
}

export default App;
